import React, { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from './Footer';
import LoadingSpinner from '../LoadingSpinner';
import RouteFocus from '../RouteFocus';
import PrivacyAndContactWidget from '../PrivacyAndContactWidget';

const Layout = () => {
  return (
    <>
      <Navbar />
      <Suspense fallback={<LoadingSpinner />}>
        <Outlet />
      </Suspense>
      <Footer />
      <PrivacyAndContactWidget />
      <ScrollRestoration />
      <RouteFocus />
    </>
  );
};

export default Layout;
